<script lang="ts">
	import type { ImageData } from '@tools/cms';
	import DatoVideo from './DatoVideo.svelte';
	import DatoImage from './DatoImage.svelte';

	let {
		data,
		isLoaded = $bindable(false),
		lazy = true
	}: {
		data: ImageData;
		isLoaded?: boolean;
		includeCaption?: boolean;
		lazy?: boolean;
	} = $props();
</script>

{#if data.responsiveImage}
	<DatoImage responsiveImage={data.responsiveImage} {isLoaded} {lazy} />
{:else if data.video}
	<DatoVideo video={data.video} {isLoaded} {lazy} />
{/if}
